import { Link } from "react-router-dom"

const LegalMenu = () => {
  return (
  <section className="enlaces-legales flex-center">
          <Link to="/aviso-legal">Aviso legal </Link>
          <hr></hr>
          <Link to="/politica-privacidad-app">Política de privacidad</Link>
          <hr></hr>
          <Link to="/politica-cookies">Política de cookies</Link>
          <hr></hr>
          <Link to="/accesibilidad">Accesibilidad</Link>
        </section>
  )
}

export default LegalMenu